import { Navigate } from "react-router-dom";
import { useUserContext } from "../../contexts";

interface ProtectedRouteProps {
	element: JSX.Element;
	allowedRoles: string[];
	path: string;
}

export const ProtectedRoute = ({
	element,
	allowedRoles,
	path
}: ProtectedRouteProps) => {
	const { user } = useUserContext();
	let hasAccess =
		user?.roles.some((role) => allowedRoles.includes(role)) || false;

	if (!hasAccess) {
		console.warn(
			`Access denied to path: ${path} for user roles: ${user?.roles}`
		);
		return <Navigate to={`/NoAccess?page=${path}`} />;
	}

	return element;
};
